import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center p-4" data-testid="payment-cancel-page">
      <div className="w-full max-w-md card-glass p-8 text-center">
        <div className="w-16 h-16 bg-[#F59E0B]/20 border-2 border-[#F59E0B] rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-10 h-10 text-[#F59E0B]" />
        </div>
        <h2 className="text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Sora' }}>Payment Cancelled</h2>
        <p className="text-white/60 mb-8" style={{ fontFamily: 'Manrope' }}>You have cancelled the payment process</p>
        <button
          onClick={() => navigate('/dashboard')}
          className="btn-primary w-full"
          data-testid="back-to-dashboard-btn"
        >
          Back to Dashboard
        </button>
      </div>
    </div>
  );
};

export default PaymentCancel;